import { render, staticRenderFns } from "./InsuranceERADetail.vue?vue&type=template&id=2018c050"
import script from "./InsuranceERADetail.vue?vue&type=script&lang=js"
export * from "./InsuranceERADetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports